import { render, staticRenderFns } from "./PhoneNumberTableComponent.vue?vue&type=template&id=ffb76b02&"
import script from "./PhoneNumberTableComponent.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffb76b02')) {
      api.createRecord('ffb76b02', component.options)
    } else {
      api.reload('ffb76b02', component.options)
    }
    module.hot.accept("./PhoneNumberTableComponent.vue?vue&type=template&id=ffb76b02&", function () {
      api.rerender('ffb76b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Elements/PhoneNumberTableComponent.vue"
export default component.exports